import PropTypes from "prop-types"

const Divider = ({ className = "" }) => (
  <div className={`border-b border-gray-300 dark:border-content2-foreground border-dotted ${className}`} />
)

Divider.propTypes = {
  className: PropTypes.string,
}

export default Divider
